import { 
  Badge,
  Input,
  Select, 
  FormControl,
  FormLabel,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton, 
  Container,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'react-redux';
import { AiOutlineExport } from "react-icons/ai";
import { FaFileExport, FaArrowLeft } from "react-icons/fa6";
import { BsThreeDotsVertical, BsFillTrash3Fill, BsBoxArrowRight } from "react-icons/bs";
import { IoIosWarning } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import { updateScanRecord, resetToImportRecord, resetScanRecord } from '@Stores/scanRecord';
import Reader, { state } from '@/assets/vender/funcodeDecoder/index.js';
import { useEffect, useRef, useState } from 'react';
import Modal from '@Components/Modal';
import { itemStatus, statusBadge } from '@Utils/parameter';
import './Scan.css'
import { resetGoogleSetting } from '../stores/googleSetting';
import { resetUserAll } from '../stores/user';

const Scan = () => {
  let tokenClient;
  const toast = useToast()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const delayDuration = 500
  const googleSheetSetting = useSelector(state => state.googleSetting.value)
  const scanRecordList = useSelector(state => state.scanRecord.value)
  const userName = useSelector(state => state.user.value.username)
  const [delay, setDelay] = useState(500)
  const [record, setRecord] = useState(null)
  const [sortRule, setSortRule] = useState()
  const noteInput = useRef()
  const sheetNameInput = useRef()
  const scanSound = useRef()
  const gapiErrorMessage = useRef(null)

  const { isOpen, onOpen, onClose} = useDisclosure()
  const { isOpen: exportIsOpen, onOpen: exportOnOpen, onClose: exportOnClose} = useDisclosure()
  const { isOpen: scanErrorIsOpen, onOpen: scanErrorOnOpen, onClose: scanErrorOnClose} = useDisclosure()
  const { isOpen: logoutIsOpen, onOpen: logoutOnOpen, onClose: logoutOnClose } = useDisclosure()

  const dateFormat = "DD/MM/YYYY HH:mm:ss"

  const sortBy = {
    none: 'none',
    latest: 'latest',
    oldest: 'oldest',
  }
 
  const checkedItems = scanRecordList.filter((item, index) => index !== 0 && item[0] !== itemStatus.NOT_CHECKED).length

  let displayRecord = scanRecordList.filter((_, index) => index !== 0).sort((a, b) => {
    if (sortRule === sortBy.none) return 0;
    if (sortRule === sortBy.latest) return (b[1] === '' ? 0 : dayjs(b[1]).valueOf()) - 
    (a[1] === '' ? 0 : dayjs(a[1]).valueOf());
    if (sortRule === sortBy.oldest) return (a[1] === '' ? 0 : dayjs(a[1]).valueOf()) - 
    (b[1] === '' ? 0 : dayjs(b[1]).valueOf());
  })

  const playSound = (beepFile) => {
    if(beepFile.current !== null) {
      beepFile.current.currentTime = 0
      beepFile.current.play()
    }
  }

  const onScan = (data) => {
    // console.log(data)
    // if (!data?.content) return;
    // 解碼僅接受資產編號的QRcode "C00004-30"
    let scanData = null
    // try {
    //   scanData = scanRecordList.find(record => record[3] === data.content)
    //   setDelay(false)
    //   playSound(scanSound)
    // } catch(err) {
    //   console.log(err);
    //   scanErrorOnOpen()
    //   return;
    // }
    // setRecord(scanData)
    // onOpen()

    try {
      const newScanResult = JSON.parse(data)?.Barcodes[0]?.Content;
      if (!newScanResult) {
        console.log("無法取得掃描內容");
        return;
      }
      // 設定新的掃描結果
      // setScanResult(newScanResult.toString());
      scanData = scanRecordList.find(record => record[3] === newScanResult)

      // 停止掃描
      setDelay(false);
      playSound(scanSound)
      console.log("掃描成功");
    } catch (error) {
      console.log("掃描處理錯誤:", error);
      scanErrorOnOpen()
      return;
    }
    console.log("scanData",scanData)
    setRecord(scanData)
    onOpen()
  }

  // 物品狀態改為符合並加上掃描時間與備註
  const approveItem = () => {
    // 利用第三欄的ID去做比對
    const IndexForImportList = scanRecordList.findIndex(item => item[3] === record[3])

    if (IndexForImportList === -1) return;
    const newScanRecordList = JSON.parse(JSON.stringify(scanRecordList))
    const item = newScanRecordList[IndexForImportList]

    // 設定狀態
    item[0] = itemStatus.COMPATIBLE
    // 設定掃描時間
    item[1] = dayjs().format(dateFormat)
    // 設定備註
    item[item.length - 1] = noteInput.current.value
    noteInput.current.value = ""

    dispatch(updateScanRecord(newScanRecordList))
    onClose()
    setDelay(delayDuration)
  }

   // 物品狀態改為不符合並加上掃描時間與備註
  const rejectItem = () => {
    // 利用第三欄的ID去做比對
    const IndexForImportList = scanRecordList.findIndex(item => item[3] === record[3]);

    if (IndexForImportList === -1) return;
    const newScanRecordList = JSON.parse(JSON.stringify(scanRecordList));
    const item = newScanRecordList[IndexForImportList];

    // 設定狀態為不符合
    item[0] = itemStatus.INCOMPATIBLE;
    // 設定掃描時間
    item[1] = dayjs().format(dateFormat);
    // 設定備註
    item[item.length - 1] = noteInput.current.value;
    noteInput.current.value = "";

    dispatch(updateScanRecord(newScanRecordList));
    onClose();
    setDelay(delayDuration);
};
  //取消登記
  const cancelUpdateRecord = () => {
    onClose()
    setDelay(delayDuration)
  }

  async function initializeGapiClient() {
    try {
      await window.gapi.client.init({
        apiKey: googleSheetSetting['apiKey'],
        discoveryDocs: ['https://sheets.googleapis.com/$discovery/rest?version=v4'],
      });
    } catch(err) {
      console.log(err);
      gapiErrorMessage.current = "API 金鑰錯誤"
      return;
    }
  }
  
  function gapiLoaded() {
    window.gapi.load('client', initializeGapiClient);
  }

  function gisLoaded() {
    tokenClient = window.google.accounts.oauth2.initTokenClient({
      client_id: googleSheetSetting['clientID'],
      scope: 'https://www.googleapis.com/auth/spreadsheets',
      callback: async (resp) => {
        if (resp.error !== undefined) {
          console.log(resp);
          throw (resp);
        }
        await addWorksheet();
      },
    });
  }

  async function addWorksheet() {
    let response;
    let sheetName;
    try {
      response = await window.gapi.client.sheets.spreadsheets.batchUpdate({
        spreadsheetId: googleSheetSetting['sheetID'],
        requests: [{
          addSheet: {
            properties: {
              title: sheetNameInput.current.value + 
              "(" +
              dayjs().format(dateFormat) +
              ")",
            }
          },
        }],
      });
      
      sheetName = response.result.replies[0].addSheet.properties.title;
      await window.gapi.client.sheets.spreadsheets.values.update({
        spreadsheetId: googleSheetSetting['sheetID'],
        range: `${sheetName}!A1:Z`,
        valueInputOption: 'RAW',
        values: scanRecordList,
      });
    } catch (err) {
      console.log(err);
      if (gapiErrorMessage.current === null) {
        gapiErrorMessage.current = err.status === 400 ? '分頁名稱不可以重複' : 'Google Sheet ID 錯誤'
      }
      toast({
        title: '匯出錯誤',
        description: gapiErrorMessage.current ?? '例外錯誤',
        status: 'error',
        duration: 2000,
        position: 'top',
        isClosable: true,
      })
      gapiErrorMessage.current = null
      return;
    } finally {
      exportOnClose()
      setDelay(delayDuration)
    }
    toast({
      title: `${sheetName} 匯出成功`,
      status: 'success',
      duration: 3000,
      position: 'top',
      isClosable: true,
    })
  }

  const exportToGoogleSheet = () => {
    gapiLoaded()
    gisLoaded()
    
    if (window.gapi.client.getToken() === null) {
      tokenClient.requestAccessToken({prompt: 'consent'});
    } else {
      tokenClient.requestAccessToken({prompt: ''});
    }
  }

  //登出
  async function logout() {
    const jwt = localStorage.getItem('_fa_jwt');
    const baseurii = 'https://funaccount.azurewebsites.net';
    
    // 如果沒有 JWT，無法正確呼叫登出 API
    if (!jwt) {
      return { success: false, message: '尚未登入或登入狀態已失效' };
    }
    
    try {
      // 呼叫登出 API
      const response = await fetch(`${baseurii}/api/v1/shinfox/Logout`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${jwt}`,
          'Content-Type': 'application/json; charset=UTF-8'
        }
      });
      
      try {
        // 嘗試解析 JSON 回應
        const json = await response.json();
        console.log('登出 API 回應:', json);
        
        if (json.returnCode === 0) {
          try {
            // 處理 Redux 狀態清理
            dispatch(resetGoogleSetting());
            dispatch(resetScanRecord());
            dispatch(resetUserAll());
            
            // 使用 Promise 確保 setTimeout 完成
            return new Promise(resolve => {
              setTimeout(() => {
                // 清除本地存儲
                localStorage.removeItem('_fa_jwt');
                localStorage.removeItem('_fa_btc');
                localStorage.removeItem('_fa_did');
                localStorage.removeItem('_fa_lit');
                localStorage.removeItem('_fa_rem');

                // 同時清理狀態物件
                state.btc = '';
                state.jwt = '';
                state.lit = '';
                state.rem = 0;
                state.did = '';
                // 解析 Promise 並返回結果
                resolve({ success: true, message: '登出成功' });
              }, 0);
            });
          } catch (dispatchError) {
            console.error('清除 Redux 狀態時出錯:', dispatchError);
            return { success: false, message: '登出過程中發生錯誤' };
          }
        } else {
          console.warn(`登出 API 回應異常 (${json.returnCode}): ${json.msg}`);
          return { success: false, message: json.msg || '登出失敗，請稍後再試' };
        }
      } catch (jsonError) {
        // JSON 解析錯誤
        console.error('解析登出 API 回應時出錯:', jsonError);
        return { success: false, message: '處理伺服器回應時出錯' };
      }
    } catch (err) {
      // 網路錯誤或其他異常
      console.error('登出 API 呼叫失敗:', err);
      return { success: false, message: `登出請求失敗: ${err.message}` };
    }
  }
  
  // 處理登出按鈕的點擊事件
  const handleLogout = async () => {
    try {
      // 關閉登出確認對話框
      logoutOnClose();
      
      // 調用登出函數並等待完成
      const result = await logout();
      
      if (result.success) {
        toast({
          title: '登出成功',
          description: result.message,
          status: 'success',
          duration: 2000,
          position: 'top',
          isClosable: true,
        });
        
        // 所有操作完成後導航到登入頁面
        navigate('/login');
      } else {
        toast({
          title: '登出失敗',
          description: result.message,
          status: 'error',
          duration: 3000,
          position: 'top',
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('登出過程中發生錯誤:', error);
      toast({
        title: '發生錯誤',
        description: '登出過程中發生意外錯誤',
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    return () => {
      setDelay(false)
    }
  }, [])

  useEffect(() => {
    if (sheetNameInput.current && userName) {
      sheetNameInput.current.value = userName;
    }
  }, [userName]);
  return (
    <div className='scan'>
      <audio id="scan-sound" src='https://confcdnnode2.azureedge.net/funeventimages/beep-normal.mp3' ref={scanSound}/>
      {/* 掃描解析錯誤 MODAL */}
      <Modal 
        isOpen={scanErrorIsOpen}
        onClose={scanErrorOnClose}
        header={<>      
          <div style={{ 
            width: '65px', 
            height: '65px',
            borderRadius: '50%', 
            backgroundColor: '#E53E3E', 
            color: '#ffdd36',
            margin: '1rem auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
            }}
          >
            <IoIosWarning style={{ fontSize: '3rem', marginTop: '-6px'}}/>
          </div>
          <h2 style={{ textAlign: 'center' }}>QR Code 格式不符合系統規範</h2>
        </>}
        ctaBtnText="繼續掃描"
        ctaHandler={() => {
          setDelay(delayDuration)
          scanErrorOnClose()
        }}
        secondaryBtnIsShow={false}
      />
      {/* 掃描確認 MODAL */}
      <Modal 
        isOpen={isOpen}
        onClose={cancelUpdateRecord}
        ctaBtnText="符合"
        secondaryBtnText="不符合"
        ctaHandler={approveItem}
        secondaryHandler={rejectItem}
        showButtons={!!record}
        header={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <span>掃描結果確認</span>
            <button 
              onClick={cancelUpdateRecord}
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              X
            </button>
          </div>
        }
      >
        <div className='record-card'>
          <div>
            {!record ?
              <h4>此物件並不在盤點清單中</h4>
            :
              record.map((keyValueArr, index) => 
                <p key={index}>{scanRecordList[0][index]} : {keyValueArr}</p>
              )
            }
          </div>
        </div>

        {record && (
          <FormControl mt='.5rem'>
            <FormLabel fontWeight='bold'>Comment</FormLabel>
            <Input
              type='text' 
              borderColor='#757474'
              ref={noteInput}
            />
          </FormControl>
        )}
      </Modal>
      {/* 匯出確認 MODAL */}
      <Modal 
        isOpen={exportIsOpen}
        onClose={exportOnClose}
        header={<>      
          <div style={{ 
            width: '65px', 
            height: '65px',
            borderRadius: '50%', 
            backgroundColor: '#2b6cb0', 
            color: 'white',
            margin: '1rem auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
            }}
          >
            <FaFileExport style={{ fontSize: '2rem'}}/>
          </div>
          <h2 style={{ textAlign: 'center' }}>匯出盤點資料</h2>
        </>}
        ctaBtnText="匯出"
        secondaryBtnText="取消"
        ctaHandler={exportToGoogleSheet}
        secondaryHandler={() => {
          exportOnClose()
          setDelay(delayDuration)
        }}
      >
        <FormControl mt='.5rem'>
          <FormLabel fontWeight='bold'>匯出的工作表名稱</FormLabel>
          <Input
            type='text' 
            borderColor='#757474'
            ref={sheetNameInput}
            defaultValue={userName}
          />
        </FormControl>
      </Modal>
      {/* 登出確認 MODAL */}
      <Modal 
        isOpen={logoutIsOpen}
        onClose={logoutOnClose}
        header={<>      
          <div style={{ 
            width: '65px', 
            height: '65px',
            borderRadius: '50%', 
            backgroundColor: '#E53E3E', // 使用紅色背景
            color: 'white',
            margin: '1rem auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
            }}
          >
            <BsBoxArrowRight style={{ fontSize: '2rem'}}/>
          </div>
          <h2 style={{ textAlign: 'center' }}>確認登出</h2>
        </>}
          ctaBtnText="確認登出"
          secondaryBtnText="取消"
          ctaBtnColor="red" // 設置按鈕為紅色
          ctaHandler={() => {
            handleLogout();
          }}
          secondaryHandler={logoutOnClose}
      >
        <p style={{ textAlign: 'center', fontSize: '1rem',}}>
          登出將會清除本機所有資料，是否確認登出?
        </p>
      </Modal>
      <div className='navbar'>
        <p style={{color: 'white', fontSize: '1.5rem'}}>Funcode</p>
        <Menu>
          <MenuButton
            as={IconButton}
            aria-label='Options'
            icon={<BsThreeDotsVertical />}
          />
          <MenuList>
            <MenuItem 
              onClick={() => {
                if (scanRecordList.length === 0) {
                  return toast({
                    title: "有盤點資料才開放匯出",
                    status: 'warning',
                    duration: 2000,
                    position: 'top',
                    isClosable: true,
                  })
                } 
                exportOnOpen()
                setDelay(false)
              }} 
              icon={<AiOutlineExport />}
            >
              匯出
            </MenuItem>
            <MenuItem 
              onClick={() => {
                dispatch(resetToImportRecord())
              }}
              icon={<BsFillTrash3Fill />}
            >
              清除所有紀錄
            </MenuItem>
            <MenuItem 
              onClick={logoutOnOpen}
              icon={<BsBoxArrowRight />}
            >
              登出
            </MenuItem>
          </MenuList>
        </Menu>
      </div>
      <Container pt='88px'>
        <IconButton
          display='block'
          isRound={true}
          variant='solid'
          backgroundColor='transparent'
          aria-label='GoBack'
          fontSize='20px'
          mb='.5rem'
          _hover={{
            backgroundColor: 'transparent',
            color: '#bababa'
          }}
          onClick={() => navigate('/home')}
          icon={<FaArrowLeft />}
        />
        <div className='camera-preview'>
          <Reader
            delay={delay}
            onError={(e) => console.log('decode error =>', e)}
            onScan={onScan}
            startupcode="default"
            debug
            symbol1dstr='000000000000000'
            symbol2dstr='1011000000'
          />
        </div>    
        {scanRecordList.length === 0 && <p style={{textAlign: 'center', fontWeight: 700}}>尚無盤點清單</p>}
        {scanRecordList.length > 0 && <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <h2 className='scan-progress'>盤點進度: {checkedItems}/{scanRecordList.length - 1}</h2>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <span style={{ whiteSpace: 'nowrap', fontWeight: 700}}>排序依</span>
            <Select ms='.5rem' onChange={(e) => setSortRule(e.target.value)}>
              <option value='none'>匯入檔案排序</option>
              <option value='latest'>掃描時間(新-&gt;舊)</option>
              <option value='oldest'>掃描時間(舊-&gt;新)</option>
            </Select>
          </div>
        </div>}
        {scanRecordList.length > 0 && displayRecord.map((data) =>
          <div 
            className='record-card' 
            key={data[3]} 
            onClick={() => {
              setDelay(false);
              setRecord(data);
              onOpen();
            }}
            style={{ 
              cursor: 'pointer',
              transition: 'transform 0.1s, background-color 0.2s',
              WebkitTapHighlightColor: 'rgba(0,0,0,0)'
            }}
            //觸控點擊時的效果
            onTouchStart={(e) => {
              e.currentTarget.style.backgroundColor = '#f0f0f0';
              e.currentTarget.style.transform = 'scale(0.98)';
            }}
            onTouchEnd={(e) => {
              e.currentTarget.style.backgroundColor = '';
              e.currentTarget.style.transform = 'scale(1)';
            }}
            // 滑鼠點擊時的效果
            onMouseDown={(e) => {
              e.currentTarget.style.backgroundColor = '#f0f0f0';
              e.currentTarget.style.transform = 'scale(0.98)';
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.backgroundColor = '';
              e.currentTarget.style.transform = 'scale(1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
        <div>
      {data.map((d, index) => 
        <p key={d+index}>
          <span style={{ fontWeight: 700 }}>{scanRecordList[0][index]}</span> 
          <span style={{ margin: '0 .25rem' }}>:</span>  
          {index === 0 ? <Badge colorScheme={statusBadge[d]}>{d}</Badge>: d}
        </p>
      )}
    </div>
  </div>
)}
      </Container>
    </div>
  )
}

export default Scan